<main class="page-shell library-page">
  <section class="card page-header">
    <div>
      <h1>Java Stream Problem Library</h1>
      <p>LeetCode-style practice focused only on Java Stream API concepts and execution quality.</p>
    </div>
    <a *ngIf="dailyChallenge() as daily" [routerLink]="['/challenge', daily.id]" class="daily-link">
      <span>Daily Stream Challenge</span>
      <strong>#{{ daily.levelNumber }} {{ daily.title }}</strong>
      <small>{{ daily.difficulty }} - +{{ daily.xpReward }} XP</small>
    </a>
  </section>

  <section class="card filters">
    <input
      type="search"
      [ngModel]="search()"
      (ngModelChange)="onSearchChange($event)"
      placeholder="Search by title, topic, or level"
    />
    <select [ngModel]="difficulty()" (ngModelChange)="onDifficultyChange($event)">
      <option value="All">All Difficulty</option>
      <option value="Beginner">Beginner</option>
      <option value="Intermediate">Intermediate</option>
      <option value="Advanced">Advanced</option>
      <option value="Expert">Expert</option>
    </select>
    <select [ngModel]="topic()" (ngModelChange)="onTopicChange($event)">
      <option *ngFor="let option of topicOptions(); trackBy: trackByTopicOption" [value]="option">{{ option }}</option>
    </select>
    <select [ngModel]="status()" (ngModelChange)="onStatusChange($event)">
      <option value="All">All Status</option>
      <option value="Solved">Solved</option>
      <option value="Unsolved">Unsolved</option>
    </select>
    <select [ngModel]="sort()" (ngModelChange)="onSortChange($event)">
      <option value="recommended">Recommended</option>
      <option value="popular">Most Popular</option>
      <option value="newest">Newest</option>
    </select>
    <button class="btn-secondary clear-btn" (click)="clearFilters()" [disabled]="!hasFilters()">Clear Filters</button>
  </section>

  <section class="category-strip" *ngIf="categories().length > 0">
    <button
      *ngFor="let category of categories(); trackBy: trackByCategory"
      type="button"
      class="chip topic-chip"
      [class.active]="topic() === category.topic"
      (click)="applyTopic(category.topic)"
    >
      {{ category.topic }}
      <strong>{{ category.count }}</strong>
    </button>
  </section>

  <section *ngIf="loading" class="card state">Loading problems...</section>
  <section *ngIf="error" class="card state error">{{ error }}</section>
  <section *ngIf="loadingProblems && !loading" class="card state">Refreshing results...</section>

  <section *ngIf="!loading && !error" class="card table-wrap">
    <table>
      <thead>
        <tr>
          <th>Bookmark</th>
          <th>Status</th>
          <th>Title</th>
          <th>Difficulty</th>
          <th>Topic</th>
          <th>Acceptance</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paged(); trackBy: trackByProblem">
          <td class="bookmark-cell">
            <button
              type="button"
              class="bookmark-btn"
              (click)="toggleBookmark(item)"
              [class.active]="item.isBookmarked"
              [disabled]="bookmarkBusy().includes(item.id)"
              [attr.aria-label]="item.isBookmarked ? 'Remove bookmark' : 'Add bookmark'"
            >
              <span [innerHTML]="item.isBookmarked ? '&#9733;' : '&#9734;'"></span>
            </button>
          </td>
          <td>
            <span
              class="status-pill"
              [class.solved]="item.status === 'COMPLETED'"
              [class.unsolved]="item.status !== 'COMPLETED'"
            >
              {{ item.status === "COMPLETED" ? "Solved" : "Unsolved" }}
            </span>
          </td>
          <td>
            <a [routerLink]="['/challenge', item.id]">
              <span class="level">#{{ item.levelNumber }}</span>
              {{ item.title }}
            </a>
          </td>
          <td>
            <span class="difficulty" [class]="item.difficulty.toLowerCase()">{{ item.difficulty }}</span>
          </td>
          <td>
            {{ item.topic }}
            <span *ngIf="item.isDaily" class="daily-badge">Daily</span>
          </td>
          <td>{{ item.acceptanceRate }}%</td>
        </tr>
      </tbody>
    </table>

    <div class="empty" *ngIf="totalCount() === 0">
      No problems match the selected filters.
    </div>

    <div class="pagination-bar" *ngIf="totalCount() > 0">
      <span class="muted">Showing {{ pageStart() }}-{{ pageEnd() }} of {{ totalCount() }}</span>
      <div class="pagination-actions">
        <button class="btn-secondary" (click)="prevPage()" [disabled]="page() === 1">Prev</button>
        <span class="page-indicator">Page {{ page() }} / {{ totalPages() }}</span>
        <button class="btn-secondary" (click)="nextPage()" [disabled]="page() === totalPages()">Next</button>
      </div>
    </div>
  </section>

  <section class="card paths-wrap" *ngIf="!loading && !error && learningPaths().length > 0">
    <div class="paths-header">
      <h2>Guided Learning Paths</h2>
      <span class="muted">Progressive tracks from fundamentals to advanced pipelines</span>
    </div>
    <div class="paths-grid">
      <article class="path-card" *ngFor="let path of learningPaths(); trackBy: trackByPath">
        <header>
          <h3>{{ path.title }}</h3>
          <span class="chip">{{ path.level }}</span>
        </header>
        <p>{{ path.solvedProblems }} / {{ path.totalProblems }} solved</p>
        <div class="progress-track">
          <span class="progress-fill" [style.width.%]="path.completionPercent"></span>
        </div>
        <small>{{ path.completionPercent }}% complete</small>
        <div class="next-problems" *ngIf="path.nextProblems.length > 0">
          <strong>Next:</strong>
          <a *ngFor="let next of path.nextProblems.slice(0, 2); trackBy: trackByNextProblem" [routerLink]="['/challenge', next.id]">
            #{{ next.levelNumber }} {{ next.title }}
          </a>
        </div>
      </article>
    </div>
  </section>
</main>
